import {
    buildAuthoringRecommendationDisplayItems,
    buildMergedAuthoringRecommendationGroupsIdle,
} from "./authoring-recommendation-groups"
import { filterVisibleAuthoringRecommendations } from "./authoring-schedule-recommendations"

export async function buildAuthoringRecommendationDisplayItemsIdle({
    recommendations = [],
    draft,
    sourceFilter = "all",
    selectedRecommendationIdsByGroupKey = {},
    yieldIdle,
}) {
    const visibleRecommendations = filterVisibleAuthoringRecommendations({ recommendations, draft })

    if (sourceFilter && sourceFilter !== "all") {
        return buildAuthoringRecommendationDisplayItems({
            recommendations,
            draft,
            sourceFilter,
            selectedRecommendationIdsByGroupKey,
        })
    }

    return buildMergedAuthoringRecommendationGroupsIdle({
        recommendations: visibleRecommendations,
        draft,
        selectedRecommendationIdsByGroupKey,
        yieldIdle,
    })
}
